import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import Register from "@/pages/Register";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Portal from "@/pages/Portal";
import LLCWorkflow from "@/pages/LLCWorkflow";
import SocialCapture from "@/pages/SocialCapture";
import AdminLogin from "@/pages/admin/AdminLogin";
import TermsOfService from "@/pages/TermsOfService";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import About from "@/pages/About";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminLeadDetails from "@/pages/admin/AdminLeadDetails";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminVideos from "@/pages/admin/AdminVideos";
import AdminTeam from "@/pages/admin/AdminTeam";
import AdminActivity from "@/pages/admin/AdminActivity";
import AdminEmailAnalytics from "@/pages/admin/AdminEmailAnalytics";
import AdminInbox from "@/pages/admin/AdminInbox";
import AdminBackgroundChecks from "@/pages/admin/AdminBackgroundChecks";
import AdminParticipants from "@/pages/admin/AdminParticipants";
import AdminMeetings from "@/pages/admin/AdminMeetings";
import AdminFeatures from "@/pages/admin/AdminFeatures";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <div className="noise-overlay" />
        <Routes>
          {/* Public */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/social/:platform" element={<SocialCapture />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/about" element={<About />} />

          {/* Participant Portal */}
          <Route path="/portal" element={<Portal />} />
          <Route path="/portal/llc" element={<LLCWorkflow />} />

          {/* Admin */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
          <Route path="/admin/leads/:id" element={<AdminLeadDetails />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="/admin/videos" element={<AdminVideos />} />
          <Route path="/admin/team" element={<AdminTeam />} />
          <Route path="/admin/activity" element={<AdminActivity />} />
          <Route path="/admin/email-analytics" element={<AdminEmailAnalytics />} />
          <Route path="/admin/inbox" element={<AdminInbox />} />
          <Route path="/admin/background-checks" element={<AdminBackgroundChecks />} />
          <Route path="/admin/participants" element={<AdminParticipants />} />
          <Route path="/admin/participants/:id" element={<AdminParticipants />} />
          <Route path="/admin/meetings" element={<AdminMeetings />} />
          <Route path="/admin/features" element={<AdminFeatures />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
